/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { CodeSnippet } from "@backstage/core";
import { pageTheme } from "@backstage/theme";
import {
  Chip,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import React from "react";
import { Fault } from "../../types";
import moment from "moment";

interface Props {
  fault: Fault;
}

export const FaultCard = ({ fault }: Props) => {
  const tags = fault.tags.map((tag: string) => (
    <Chip label={tag} key={tag} size="small" />
  ));
  const subheader = `Last Seen: ${moment(
    fault.last_notice_at
  ).fromNow()} - Total Occurrences: ${fault.notices_count}`;

  return (
    <Card data-testid="fault-card">
      <CardHeader
        title={`${fault.project_name} (${fault.project_id}): ${fault.klass} in ${fault.component}`}
        subheader={subheader}
        style={{
          backgroundImage: pageTheme.app.backgroundImage,
          backgroundSize: "cover",
          color: "white",
        }}
      />
      <CardContent>
        <CodeSnippet text={fault.message} language="shell" showLineNumbers />
        {tags}
        <CardActions>
          <Button size="small" href={fault.url}>
            View Error on Honeybadger{" "}
            <ArrowForwardIcon
              style={{ position: "relative", top: "-2px", marginLeft: "2px" }}
            />
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};
